import { wei } from '@kwenta/wei'

import { PerpsProvider } from 'state/futures/types'

export const PERPS_VERSIONS_ENABLED = process.env.NEXT_PUBLIC_PERPS_VERSIONS_ENABLED ?? 'both' // v2 | v3 | both

export const SNX_V2_ENABLED = PERPS_VERSIONS_ENABLED === 'v2' || PERPS_VERSIONS_ENABLED === 'both'
export const SNX_V3_ENABLED = PERPS_VERSIONS_ENABLED === 'v3' || PERPS_VERSIONS_ENABLED === 'both'

export const DEFAULT_PERPS_PROVIDER = SNX_V3_ENABLED ? PerpsProvider.SNX_V3 : PerpsProvider.SNX_V2

export const DEFAULT_MAX_EXECUTOR_FEE_USD = wei(1)
